import axios from "axios";

const state = () => ({
    scheduledTournaments: []
})

// mutations
const mutations = {
    setScheduledTournaments(state, data) {
        state.scheduledTournaments = data;
    }
}

// actions
const actions = {
    getScheduledTournaments({commit}) {
        axios.get(`/api/tournament-waiting-room/scheduled`)
            .then(function (response) {
                commit('setScheduledTournaments', response.data.items);
            })
            .catch(error => {
                console.log(error);
            });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
